<script>
import Testimonial from "../Testimonial.vue";

export default {
  components: { Testimonial },
  name: "PowerDropsLeft",
  data: function() {
    return {
      testimonials: {
        kristin: {
          photo: "powerdrops/testimonial-kristin.png",
          name: "Kristín Sjofn",
          quote: `Woww!!! It is like coming out of the "dark ages"... Thanks for the class. It is not too much chemistry for me because it is so colorful and fun.`
        },
        tammy: {
          photo: "powerdrops/testimonial-tammy.png",
          name: "Tammy Kell",
          quote: `I just watched Lesson One. LOVED IT!!! Wrote a full page of notes. I absolutely LOVE learning and feel SO fortunate I found Dropsmart. I can't wait for the next lesson. VERY informative.
                    Melani, you have inspired and motivated me to continue my aromatherapy journey. I appreciate you very much. Your team as well. Leandro has been phenomenal assisting me when I've had technical problems!!
                    Please continue to include chemistry education as I feel it is truly important for the overall understanding of using and blending.`
        },
        sylvia: {
          photo: "powerdrops/testimonial-sylvia.png",
          name: "Sylvia Provenski",
          quote: `I absolutely LOVE Dropsmart! And I love our Power Drops course! I go on every day and check out different conditions and then look at which are the best oils for that condition. I'm always surprised at what I find!`
        }
      }
    };
  }
};
</script>
<template>
  <div id="pd-left-container">
    
    <!--div id="special-offer">
      <h2>
        SAVE 93%
      </h2>
      <p><strong><span style="background: #ffea01; font-weight: bold;">Total value: <strike>€ 27,685+</strike></span></strong><br /><span style="background: #ffea01; font-size: 0.7em;">Keep reading...</span></p>
    </div-->

    <div id="program-content">
      <h3>Power Drops Next Level Program:</h3>
      <img src="@/assets/powerdrops/NL-Melani-Method-check-out-picture.png" width="100%" style="margin-bottom: 1em;">
      <ul>
        <li>6 Core Lessons</li>
        <li>15 Power-blending mini-modules</li>
        <li>5 Mini-modules for aromatherapy educators</li>
        <li>Certificate of attendance</li>
        <li>PDF lesson material</li>
        <li>190+ pages of printable workbooks</li>
        <li>Full-year personal guidance through the program</li>
        <li>PowerVIP community: your personal questions answered</li>
        <li>Lifetime access</li>
      </ul>
      <h3>Plus 12 Incredible BONUSES:</h3>
      <ul>
        <li>
          First Year of Dropsmart Premium Subscription
          <br />
          <small>* Your subscription will automatically renew. You can cancel at any time.</small>
        </li>
        <li>Calculator for converting drops to ml, oz, etc.</li>
        <li>Supportive VIP community</li>
        <li>Evergreen BONUS section</li>
        <li>Bonus PDF on basic essential oil chemistry</li>
        <li>Bonus PDF on safety recommendations for children (complementing one of the mini-modules)</li>
        <li>Bonus Video Tips and Tricks for Moms and Kids</li>
        <li>Bonus lesson: On blending, ratios, smell &amp; essential oil chemistry </li>
        <li>Plus more BONUS videos</li>
        <li><strong>€ 200 gift card</strong>
          <br />
          <small>*You can use this card to make one purchase on any product on Melani Method. It's valid until the end of 2022.</small>
        </li>
        <li>Modern Cosmetics - Module 1</li>
        <li>Modern Cosmetics - Module 2</li>
      </ul>
    </div>

    <div>
      <b-card no-body class="overflow-hidden" style="font-size: 0.8em; border: none; margin-top: 3rem">
        <b-row no-gutters>
          <b-col md="3">
            <b-card-img :src="require('@/assets/aromaempress/Just-30-Days-Guarantee.jpg')"/>
          </b-col>
          <b-col md="9">
            <b-card-body title="30-Day Money-Back Guarantee">
              <b-card-text>
              Try it <strong>100% RISK-FREE with our 30-day money-back guarantee</strong>. If you change your mind within 30 days for any reason, and you feel it's not the moment to continue with the program, email us, and we will take care of your refund.
              This means you get 30 days of test driving, on us.
               </b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>      
    </div>
    
    <!--div id="special-offer">
      <h2>
        SAVE 93%
      </h2>
      <p><strong><span style="background: #ffea01; font-weight: bold;">Get <strike>€ 27,685+</strike></span></strong><br /><span style="background: #ffea01; font-size: 0.7em;">For only € 1,997</span></p>
    </div-->

    <div class="testimonials">
    <Testimonial :testimonial="testimonials.kristin" />
    <Testimonial :testimonial="testimonials.tammy" />
    <Testimonial :testimonial="testimonials.sylvia" />
    </div>
  </div>
</template>

<style lang="scss">
@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

* {
  font-family: $font-family;
}

#pd-left-container {
  font-size: 1.11rem;
  flex-basis: 100%;
}

#special-offer {
  margin-top: 2em;
  margin-bottom: 2em;
  h2 {
    color: #e00b11;
    font-size: 2em;
    text-transform: uppercase;
    text-align: center;
    font-weight: $font-bold;
  }
  p {
    font-size: 2.5em;
    text-align: center;
  }
}

.bonus {
   margin-left: 10px;
    display: inline;
}

#program-content {
  line-height: 1.77em;
  font-size: 1.25em;
  color: #293847;
  h3 {
    color: #e00b11;
    font-weight: 700;
    margin-top: 1em;
    margin-bottom: 1em;
  }
  h4 {
    font-size: 1em;
    font-weight: 600;
    margin-bottom: 1em;
  }
  ul {
    margin-left: 1em;
    padding: 0;
  }
}

</style>
